/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import { showToast } from 'vant';
import { getEqulistForPatrol, getDeviceInspectBoardForPatrol } from '@/service/operate/dailyInspection';
import CDateSelect from './cpns/CDateSelect.vue';
export default defineComponent({
  name: 'DailyInspection',
  components: {
    CDateSelect: CDateSelect
  },
  setup: function setup() {
    var date = ref(dayjs().format('YYYY/MM/DD'));
    var list = ref([]);
    //获取当月的日期
    //1.获取当月有多少天
    var dayNum = ref(dayjs(date.value).daysInMonth());
    //2.获取本月一号是星期几(0-6)
    var monthStartDay = ref(dayjs(dayjs(date.value).format('YYYY-MM-01')).day());
    //3.获取本月最后一天是星期几
    var monthEndDay = ref(dayjs(dayjs(date.value).format("YYYY-MM-".concat(dayNum.value))).day());
    // 4.日期列表list数组的长度为 monthStartDay.value + dayNum.value + (6 - monthEndDay)
    list.value = new Array(monthStartDay.value + dayNum.value + (6 - monthEndDay.value));
    //获取日期列表list数组的起始日期
    var listStartDate = ref(dayjs(dayjs(date.value).format('YYYY-MM-01')).subtract(monthStartDay.value, 'day').format('YYYY-MM-DD'));
    for (var i = 0; i < list.value.length; i++) {
      list.value[i] = {
        date: dayjs(listStartDate.value).add(i, 'day').format('YYYY-MM-DD'),
        not_patrol_point_num: 0,
        patrol_point_num: 0,
        status: 4
      };
    }
    var confrimDate = function confrimDate(val) {
      date.value = val;
      //获取当月的日期
      //1.获取当月有多少天
      dayNum.value = dayjs(date.value).daysInMonth();
      //2.获取本月一号是星期几(0-6)
      monthStartDay.value = dayjs(dayjs(date.value).format('YYYY-MM-01')).day();
      //3.获取本月最后一天是星期几
      monthEndDay.value = dayjs(dayjs(date.value).format("YYYY-MM-".concat(dayNum.value))).day();
      // 4.日期列表list数组的长度为 monthStartDay + dayNum.value + (6 - monthEndDay.value)
      list.value = new Array(monthStartDay.value + dayNum.value + (6 - monthEndDay.value));
      listStartDate.value = dayjs(dayjs(date.value).format('YYYY-MM-01')).subtract(monthStartDay.value, 'day').format('YYYY-MM-DD');
      for (var _i = 0; _i < list.value.length; _i++) {
        list.value[_i] = {
          date: dayjs(listStartDate.value).add(_i, 'day').format('YYYY-MM-DD'),
          not_patrol_point_num: 0,
          patrol_point_num: 0,
          status: 4
        };
      }
      getDeviceInspectBoardAsync();
    };
    var getDeviceInspectBoardAsync = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _list$value;
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDeviceInspectBoardForPatrol({
                monthDate: dayjs(date.value).format('YYYY-MM')
              });
            case 2:
              data = _context.sent;
              (_list$value = list.value).splice.apply(_list$value, [monthStartDay.value, dayNum.value].concat(_toConsumableArray(data.list)));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getDeviceInspectBoardAsync() {
        return _ref.apply(this, arguments);
      };
    }();
    var dateFormat = function dateFormat(val) {
      return dayjs(val).format('DD');
    };
    var bgFormat = function bgFormat(dateString, status) {
      // 巡检状态 0正常巡检 1未巡检 2未巡检完 3未来日期
      var className = '';
      var curMonth = dayjs(date.value).month();
      var targetMonth = dayjs(dateString).month();
      if (curMonth === targetMonth) {
        if (status === 0) {
          className += 'bg-green';
        }
        if (status === 1) {
          className += 'bg-red';
        }
        if (status === 2) {
          className += 'bg-blue';
        }
        if (dateString == checkDate.value) {
          className += ' active';
        }
      }
      return className;
    };
    var detail = ref([]);
    var checkDate = ref(dayjs().format('YYYY-MM-DD'));
    var dateSelectRef = ref();
    var dateItemClick = function dateItemClick(item) {
      var curDate = item.date;
      if (dayjs(curDate).isBefore(dayjs(dayjs(date.value).format('YYYY-MM-01')))) {
        var _dateSelectRef$value;
        (_dateSelectRef$value = dateSelectRef.value) === null || _dateSelectRef$value === void 0 || _dateSelectRef$value.preClick();
        detail.value = [];
      } else if (dayjs(curDate).isAfter(dayjs(dayjs(date.value).format("YYYY-MM-".concat(dayNum.value))))) {
        var _dateSelectRef$value2;
        (_dateSelectRef$value2 = dateSelectRef.value) === null || _dateSelectRef$value2 === void 0 || _dateSelectRef$value2.nextClick();
        detail.value = [];
      } else if (dayjs(curDate).isAfter(dayjs())) {
        showToast('不能查询未来日期');
        detail.value = [];
      } else {
        checkDate.value = curDate;
        getEqulistForPatrol({
          date: item.date
        }).then(function (data) {
          detail.value = data.list;
          console.log(data);
        });
      }
    };
    onMounted(function () {
      //获取日历数据
      getDeviceInspectBoardAsync();
      getEqulistForPatrol({
        date: checkDate.value
      }).then(function (data) {
        detail.value = data.list;
        console.log(data);
      });
    });
    var router = useRouter();
    var go = function go(id, state) {
      router.push('/DailyInspectionDetail?id=' + id + '&state=' + state + '&date=' + checkDate.value);
      console.log(id, state);
    };
    return {
      list: list,
      confrimDate: confrimDate,
      dateFormat: dateFormat,
      bgFormat: bgFormat,
      dateSelectRef: dateSelectRef,
      dateItemClick: dateItemClick,
      detail: detail,
      go: go
    };
  }
});